import { v4 as uuid } from 'uuid';
import { invalidFormNameChar } from './constants';
import { FileContentType } from './file-content-type.enum';
import { FileType } from './file-type.enum';
import { assignSafe } from './functions/assign-safe';
import { IFileRefIsLocal, IFileReference } from './i-file-reference';

export class FileReference implements IFileReference {
  id: string;
  name: string;
  path: string;
  blobPath?: string; // Required for dynamic file loading
  order: number;
  fileType: FileType;
  contentType: FileContentType;
  local: boolean;

  constructor(jsonData: Partial<FileReference> | IFileReference) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
    this.id ??= uuid();
    this.contentType ??= FileContentType.Attachment;
  }

  get baseName(): string {
    const pieces = this.name?.split('.');
    if (pieces?.length <= 1) return this.name;
    pieces.pop();
    return pieces.join('.').trim();
  }

  get cleanPath(): string {
    return this.path.replace(invalidFormNameChar, '-');
  }

  get isLocal(): boolean {
    return IFileRefIsLocal(this);
  }
}
